var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"history"},[_c('div',{staticClass:"history-menu"},[_c('MenuHistory')],1),_c('div',{staticClass:"history-content"},[_c('TransactionHistory')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }